import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withStateHandlers from 'recompose/withStateHandlers'
import withHandlers from 'recompose/withHandlers'
import Textfit from 'react-textfit'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'
import ShareButton from 'aria-viewer/tour/components/buttons/shareButton'

import { MEDIA_SIZES } from 'aria-viewer/tour/constants'
import { AUDIO_SUPP } from 'aria-viewer/audiomanager/audioManagerActions'
import MediaComponent from 'aria-viewer/media/components/mediaComponent'
import StyleGuide from 'aria-viewer/tour/constants/styleGuide'
import { VideoPlayer } from 'aria-viewer/legacy'

const styleSheet = theme => ({
    header: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 16,
    },

    body: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: -1,
        transition: 'opacity .2s ease-in-out',
        opacity: ({ hasLoaded }) => (hasLoaded ? 1 : 0),
    },

    shareButton: {
        '& svg path': {
            fill: theme.palette.common.white,
        },

        '& div': {
            width: 18,
            height: 21,
        },
    },

    title: {
        position: 'absolute',
        bottom: 16,
        left: 8,
        right: 8,
        color: theme.palette.common.white,
        fontSize: 34,
        textShadow: '0 4px 8px rgba(0, 0, 0, 0.7)',
        height: 100,
        transition: 'opacity .2s ease-in-out',
        pointerEvents: 'none',
        opacity: ({ showMediaTitle }) => (showMediaTitle ? 1 : 0),
    },

    image: {
        height: 375,
        width: '100%',
    },
})

const style = injectSheet(styleSheet)

const inlineStyle = {
    shareButton: {
        display: 'flex',
        width: 36,
        height: 36,
        alignItems: 'center',
        marginRight: 16,
    },
}

const state = withStateHandlers(({ hasLoaded = false, showMediaTitle = true }) => ({ hasLoaded, showMediaTitle }), {
    setHasLoaded: _ => loaded => ({ hasLoaded: loaded }),
    setShowMediaTitle: _ => show => ({ showMediaTitle: show }),
})

const handlers = withHandlers(({ setHasLoaded, setShowMediaTitle }) => ({
    onLoad: _ => e => setHasLoaded(true),
    onPlay: _ => e => setShowMediaTitle(false),
}))

const MediaFullScreen = ({ classes, className, media, title, onClose, containerSize, onLoad, onPlay, ...props }) => (
    <div className={className}>
        <div className={classes.body}>
            <MediaComponent
                audioType={AUDIO_SUPP}
                active={true}
                enableClick={true}
                enableInteractiveElements={false}
                options={{ ...media, autoplay: false, size: MEDIA_SIZES.medium, disableBlur: true }}
                aspect="fit"
                showUI={media.type == VideoPlayer.types.AWS} /* only use system UI for AWS */
                style={containerSize}
                secondaryOptions={{
                    startCoord: {
                        lat: media.start_lat ? media.start_lat : 0,
                        lon: media.start_lon ? media.start_lon : 0,
                    },
                    delay: StyleGuide.delay.mainMediaTransition,
                }}
                key={media.type + '_' + media.id}
                onLoad={onLoad}
                onPlay={onPlay}
            />
        </div>

        <Textfit className={classes.title} mode="multi" min={10} max={34}>
            {title}
        </Textfit>

        <div className={classes.header}>
            <CloseButton onClick={onClose} />

            <ShareButton style={inlineStyle.shareButton} className={classes.shareButton} />
        </div>
    </div>
)

export default compose(
    state,
    handlers,
    style,
    pure
)(MediaFullScreen)
